import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Grid,
  Loader,
  Dimmer,
  Button
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { cleanUp, toggleAddModal } from './actions';
import { entriesWatch, tagsWatch, unlisten, addUrls } from 'data/actions';

import AddUrlsModal from 'components/AddUrlsModal';
import FilterByTagsBar from './components/FilterByTagsBar';
import FilterContainer from './components/FilterContainers';
import EditPanelContainer from './components/EditPanelContainer';
import './style.css';

class Main extends Component {
  static propTypes = {
    tagsWatch: PropTypes.func,
    entriesWatch: PropTypes.func,
    logoutUser: PropTypes.func,
    entrySelected: PropTypes.bool
  };

  state = { urlsToAdd: ""}

  componentWillMount() {
    this.props.tagsWatch();
    this.props.entriesWatch();
  }

  componentWillUnmount() {
    this.props.cleanUp();
    this.props.unlistenToData();
  }

  render() {
    const { entriesSelected, entries } = this.props;
    return (
      <Container fluid className="main-scene">
        <Dimmer inverted={true} active={this.props.loading}>
          <Loader />
        </Dimmer>
        {entriesSelected.length > 0 && (
          <EditPanelContainer
            handleOpenExternal={() => {
              for (let e of entriesSelected) {
                window.open(entries[e.id].url, '_blank');
              }
            }}
          />
        )}
        <FilterByTagsBar />
        <Container fluid className="page-container">
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={14} className="workspace-col">
                <FilterContainer.EntriesGrid />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
        <Link to='/faq'>
          <Button
            className="help-button"
            circular
            size="small">
            ?
          </Button>
        </Link>
        <Button
          className="add-button"
          primary
          circular
          size="huge"
          onClick={() => { this.props.toggleAddModal(true) }}
        >
          +
        </Button>
        <AddUrlsModal
          open={this.props.modalIsOpen}
          onCancel={() => this.props.toggleAddModal(false)}
          onDone={() => this.props.toggleAddModal(false)}
          addUrls={this.props.addUrls}
        />
      </Container>
    );
  }
}

const mapStateToProps = ({ scene, data }) => {
  return {
    entriesSelected: scene.main.entriesSelected,
    entries: data.entries,
    modalIsOpen: scene.main.addModalOpen,
    loading: scene.main.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    cleanUp: () => { dispatch(cleanUp()); },
    entriesWatch: () => { dispatch(entriesWatch()); },
    tagsWatch: () => { dispatch(tagsWatch()); },
    unlistenToData: () => { dispatch(unlisten()); },
    toggleAddModal: (open) => { dispatch(toggleAddModal(open)) },
    addUrls: (urls) => { dispatch(addUrls(urls)); }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/scenes/Main/index.js